import Vue from 'vue'
export default {
    handleError: function (context, r = null) {
        if (r && r.status == 401) {
            const response = this.handleSuccess(r);
            if (response && response['break-auth']) context.dispatch('users/authReset');
            if (response && response['block-auth']) {
                context.commit('handleSnackError', [r, 6000]);
                context.dispatch('users/authReset');
            }
            return;
        }

        if (r) context.commit('handleSnackError', [r, 6000]);
        else context.commit('handleSnackError', ['Произошла неизвестная ошибка', 6000]);

        return null;
    },
    handleSuccess: function (r) {
        return (r && r.body && r.body.response ? r.body.response : r);
    },
    get: function ({context, rootState}, url, data) {
        return Vue.http.get(rootState.endpoint + url, data).then(
            r => this.handleSuccess(r),
            r => this.handleError(context, r)
        ).catch(e => this.handleError(context, e));
    },
    post: function ({context, rootState}, url, data) {
        return Vue.http.post(rootState.endpoint + url, data).then(
            r => this.handleSuccess(r),
            r => this.handleError(context, r)
        ).catch(e => this.handleError(context, e));
    },
    put: function ({context, rootState}, url, data) {
        return Vue.http.put(rootState.endpoint + url, data).then(
            r => this.handleSuccess(r),
            r => this.handleError(context, r)
        ).catch(e => this.handleError(context, e));
    },
    delete: function ({context, rootState}, url, data) {
        return Vue.http.delete(rootState.endpoint + url, data).then(
            r => this.handleSuccess(r),
            r => this.handleError(context, r)
        ).catch(e => this.handleError(context, e));
    },
}


// WEBPACK FOOTER //
// ./src/helpers/http/index.js